module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/CatCard-fcc956ef0ccc62c064cf0e0f0a9bf9c6.png";